import { render, staticRenderFns } from "./ReportsAdminDepartment.vue?vue&type=template&id=a6323700&scoped=true"
import script from "./ReportsAdminDepartment.vue?vue&type=script&lang=js"
export * from "./ReportsAdminDepartment.vue?vue&type=script&lang=js"
import style0 from "./ReportsAdminDepartment.vue?vue&type=style&index=0&id=a6323700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6323700",
  null
  
)

export default component.exports